export function GetDateDetails(dateString) {
  const targetDate = new Date(dateString);
  const now = new Date();

  const day = targetDate.toLocaleDateString("en-US", { weekday: "long" });

  const dayNum = targetDate.getDate();
  const suffix = ((d) => {
    if (d > 3 && d < 21) return "th";
    switch (d % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  })(dayNum);

  const dayStr = String(dayNum).padStart(2, "0");
  const month = targetDate.toLocaleString("en-US", { month: "long" });
  const year = targetDate.getFullYear();

  const time = targetDate.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  const diffTime = targetDate.getTime() - now.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))-1;
  const formattedNoteNumber = String(Math.abs(diffDays)).padStart(2, "0");
  const note =
    diffDays === 0
      ? { count: "00", firstWord: "TODAY", restText: "" }
      : diffDays === 1
      ? { count: "01", firstWord: "DAY", restText: "TO GO" }
      : diffDays < 0
      ? { count: formattedNoteNumber, firstWord: "DAYS", restText: "AGO" }
      : { count: formattedNoteNumber, firstWord: "DAYS", restText: "TO GO" };

  return {
    day,
    dayStr,
    suffix,
    month,
    year,
    time,
    note,
  };
}
